"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const utils_1 = require("../utils");
function getToken(connection, mintAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        const splToken = new spl_token_1.Token(connection, mintAddress, spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.Keypair.generate() // dummy signer since we aren't making any txs
        );
        return new utils_1.Token(mintAddress, yield splToken.getMintInfo());
    });
}
exports.getToken = getToken;
//# sourceMappingURL=utils.js.map